import React from 'react';

interface FaithCircleCandleIconProps {
  fill?: string;
  className?: string;
}

export const FaithCircleCandleIcon: React.FC<FaithCircleCandleIconProps> = ({ fill = '#BCD7CF', className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="111"
    height="111"
    viewBox="0 0 111 111"
    fill="none"
    className={className}
  >
    {/* Circle - 110.635×110.635, stroke 6 */}
    <circle cx="55.3176" cy="55.3176" r="52.3176" stroke={fill} strokeWidth="6" />
    {/* Candle - centered in circle (center 55.3176,55.3176; candle center 21.5,34.5) */}
    <g transform="translate(33.8176, 20.8176)">
      <path
        d="M19.9629 0.25293L19.9619 0.253906C20.4175 0.274793 20.8356 0.493453 21.1162 0.847656C24.6632 4.55557 26.4914 9.56766 26.1572 14.6729V14.6836L26.1553 14.6934C25.6439 18.0864 23.9149 21.1828 21.2959 23.415V26.7881H28.5723C29.0016 26.7881 29.4159 26.9571 29.7207 27.2598C30.0253 27.5624 30.1963 27.9737 30.1963 28.4014V65.0215L40.2715 64.9678H40.2734C41.1685 64.9679 41.8963 65.6882 41.8965 66.5811C41.8965 67.4742 41.1677 68.1943 40.2725 68.1943L1.87402 68.25H1.87305C0.978132 68.2498 0.25017 67.5296 0.25 66.6367C0.25 65.7437 0.978025 65.0227 1.87305 65.0225H9.09473V28.4014C9.09473 27.5083 9.82276 26.7883 10.7178 26.7881H18.1865V23.2002C15.2488 20.7891 13.4478 17.2792 13.2158 13.499L13.2148 13.4873V13.4746C13.382 8.68697 15.3585 4.13775 18.7539 0.735352C19.0628 0.400802 19.5075 0.224693 19.9629 0.25293ZM12.5615 64.9678H26.9502V30.0146H12.5615V64.9678ZM21.2969 18.5625C22.1491 17.2704 22.7115 15.8059 22.9395 14.2725C23.1824 10.6848 22.0656 7.13933 19.8105 4.33301C17.7109 6.89783 16.5263 10.0877 16.4619 13.3965C16.5239 15.1663 17.0766 16.8801 18.0498 18.3525V16.9463C18.05 16.0534 18.7779 15.3331 19.6729 15.333H19.6777C20.5625 15.3491 21.2806 16.0598 21.2969 16.9424V18.5625Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.5"
        strokeMiterlimit="16"
      />
    </g>
  </svg>
);
